<template>
  <div class="yxtbiz-project-audit" v-loading="loading">
    <div class="yxtbiz-project-audit__title">{{$t('pc_biz_pulish_project_audit' /* 项目发布审核 */)}}</div>
    <yxt-row class="yxtbiz-project-audit__row" :gutter="32">
      <yxt-col :span="12" class="yxtbiz-project-audit__col">
        <div class="color-gray-7 yxtbiz-project-audit__label">{{$t('pc_biz_ojt_lbl_projectname' /* 项目名称 */)+ $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
        <yxt-tooltip
          :content="project.projectName"
          placement="top"
          open-filter
        >
          <div class="color-gray-10 ellipsis nowrap">
            {{project.projectName}}
          </div>
        </yxt-tooltip>
      </yxt-col>
      <yxt-col :span="12" class="yxtbiz-project-audit__col">
        <div class="color-gray-7 yxtbiz-project-audit__label">
          {{$t('pc_o2o_lbl_relative_plan_name' /* 关联培训计划 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}
        </div>
        <yxt-tooltip
          v-if="project.planName"
          :content="project.planName"
          placement="top"
          open-filter
        >
          <div class="color-gray-10 ellipsis nowrap">
            {{project.planName}}
          </div>
        </yxt-tooltip>
        <div v-else class="color-gray-10">--</div>
      </yxt-col>
    </yxt-row>
    <yxt-row class="yxtbiz-project-audit__row" :gutter="32">
      <yxt-col :span="12" class="yxtbiz-project-audit__col">
        <div class="color-gray-7 yxtbiz-project-audit__label">{{$t('pc_biz_training_lbl_classification' /* 分类 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
        <yxt-tooltip
          v-if="project.catalogName"
          :content="project.catalogName"
          placement="top"
          open-filter
        >
          <div class="color-gray-10 ellipsis nowrap">
            {{project.catalogName}}
          </div>
        </yxt-tooltip>
        <div v-else class="color-gray-10">--</div>
      </yxt-col>
       <yxt-col class="yxtbiz-project-audit__col" :span="12">
        <div class="color-gray-7">{{$t('pc_biz_enroll_lbl_projecttime' /* 项目时间 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
        <div v-if="project.timeType === 0" class="color-gray-10">{{project.startTime ? `${project.startTime.slice(0, 16)} ~ ${project.endTime.slice(0, 16)}` : '--'}}</div>
        <div v-else-if="project.timeType === 1" class="color-gray-10">{{project.cycle}}{{$t('pc_biz_rule_unit_day' /* 天 */)}}</div>
      </yxt-col>
    </yxt-row>
    <yxt-row class="yxtbiz-project-audit__row" :gutter="32">
      <yxt-col class="yxtbiz-project-audit__col" :span="12">
        <div class="color-gray-7">{{$t('pc_biz_project_creator' /* 项目创建人 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
        <div class="color-gray-10">{{project.createName}}</div>
      </yxt-col>
      <yxt-col :span="12" class="yxtbiz-project-audit__col">
        <div class="color-gray-7 yxtbiz-project-audit__label">{{$t('pc_biz_project_owner' /* 项目负责人 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
        <yxt-tooltip
          placement="top"
          open-filter
        >
        <div slot="content">
          <yxtbiz-user-name :name="(project.relatedUserName || []).join(';')" />
        </div>
          <div class="color-gray-10 ellipsis nowrap">
            <yxtbiz-user-name :name="(project.relatedUserName || []).join(';')" />
          </div>
        </yxt-tooltip>
      </yxt-col>
    </yxt-row>
    <yxt-row class="yxtbiz-project-audit__row" :gutter="32">
      <yxt-col :span="12" class="yxtbiz-project-audit__col">
        <div class="color-gray-7 yxtbiz-project-audit__label">{{$t('pc_biz_formal_learner_num' /* 学员总数（正式） */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
        <div class="color-gray-10">{{project.userCount !== 0 &&!project.userCount ? '--' : project.userCount }}</div>
      </yxt-col>
       <yxt-col class="yxtbiz-project-audit__col" :span="12">
        <div class="color-gray-7">{{$t('pc_o2o_lbl_total_budget_amount' /* 预算金额总和 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
        <div class="color-gray-10">{{project.budgetSum | numWithThousandth}}</div>
      </yxt-col>
    </yxt-row>
    <yxt-row class="yxtbiz-project-audit__row" :gutter="32">
      <yxt-col :span="24">
        <yxt-button @click="goProjectDetail" type="text">{{$t('pc_biz_view_project_detail' /* 查看项目详情 */)}}</yxt-button>
      </yxt-col>
    </yxt-row>
  </div>
</template>

<script>
import {getProject} from './service';
export default {
  name: 'YxtbizProjectAudit',
  name_zh: '培训项目审核',
  data() {
    return {
      loading: false,
      project: {}
    };
  },
  mounted() {
    this.fetchProject(this.formId);
  },
  props: {
    formId: {
      type: String,
      required: true,
      default: '',
      desc: '审核 FormID',
      setter: 'StringSetter'
    }
  },
  filters: {
    numWithThousandth(num) {
      if (num !== 0 && !num) return '--';
      return (+num || 0).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  },
  methods: {
    fetchProject() {
      this.loading = true;
      getProject(this.formId)
        .then(res => (this.project = res))
        .finally(() => (this.loading = false));
    },
    goProjectDetail() {
      if (this.project.deleted === 1) return this.$message.error(this.$t('pc_biz_o2o_msg_projectundefined' /* 项目已删除 */));
      const url = `${window.location.origin}/o2o/#/preview/projectconsole/projectmgmt?id=${this.formId}`;
      window.open(url);
    }
  }
};
</script>
